/*
 * Public API Surface of portal-common-component-lib
 */

export * from './lib/translate/translate.module';
export * from './lib/translate/translate.service';
export * from './lib/translate/translate.pipe';

//----Components-Depositi-----//
export * from './lib/depositi/depositi.module';
export * from './lib/depositi/components/richiedente/richiedente.component';
export * from './lib/depositi/components/deleghe/deleghe.component';
export * from './lib/depositi/components/accettazione/accettazione.component';
export * from './lib/depositi/components/documentazione/documentazione.component';
export * from './lib/depositi/components/tipologia-deposito/tipologia-deposito.component';
export * from './lib/depositi/components/pagamento/pagamento.component';
export * from './lib/depositi/components/dati-deposito/dati-deposito.component';
export * from './lib/depositi/components/altri-soggetti/altri-soggetti.component';
export * from './lib/depositi/common-component/stepper-navigator/stepper-navigator.component';
export * from './lib/depositi/common-component/ricerca-pg/ricerca-pg.component';
export * from './lib/depositi/common-component/ricerca-pf/ricerca-pf.component';
export * from './lib/depositi/normalizzazione/component-output-status';
export * from './lib/depositi/common-component/generic-modal/generic-modal.component';
export * from './lib/depositi/common-component/dati-tribunale/dati-tribunale.component';
export * from './lib/depositi/common-component/indirizzo/indirizzo.component';
export * from './lib/depositi/common-component/contatti/contatti.component';
export * from './lib/depositi/common-component/generic-modal/generic-modal-data';
export * from './lib/depositi/common-component/ricerca-pg/pg/pg.component';
export * from './lib/depositi/common-component/ricerca-pf/pf/pf.component';
export * from './lib/depositi/common-component/persona-fisica/persona-fisica.component';
export * from './lib/depositi/common-component/persona-giuridica/persona-giuridica.component';
export * from './lib/depositi/common-component/persona-giuridica/tabella-sedi/tabella-sedi.component';

//----Models-Depositi-----//
export * from './lib/depositi/models/dati-deposito-giudiziario-dto';
export * from './lib/depositi/models/tipologica-d-t-o';
export * from './lib/depositi/models/modalita-pagamento-dto';
export * from './lib/depositi/models/portale/persona-fisica-model';
export * from './lib/depositi/models/portale/persona-giuridica-model';
export * from './lib/depositi/models/portale/cittadinanza';
export * from './lib/depositi/models/portale/comune';
export * from './lib/depositi/models/portale/dati-persona-fisica';
export * from './lib/depositi/models/portale/dati-persona-giuridica';
export * from './lib/depositi/models/portale/domicilio';
export * from './lib/depositi/models/portale/indirizzo';
export * from './lib/depositi/models/portale/localita';
export * from './lib/depositi/models/portale/nazione';
export * from './lib/depositi/models/portale/recapito';
export * from './lib/depositi/models/portale/sede';
export * from './lib/depositi/models/portale/tipologica';
export * from './lib/depositi/models/mie-deleghe-dto';
export * from './lib/depositi/models/tipo-documento';
export * from './lib/depositi/models/costituzione-deposito-dto';
export * from './lib/depositi/models/costituzione-deposito-volontario-dto';
export * from './lib/depositi/models/costituzione-deposito-cauzionale-dto';
export * from './lib/depositi/models/costituzione-deposito-esproprio-dto';
export * from './lib/depositi/models/costituzione-deposito-giudiziario-dto';
export * from './lib/depositi/models/costituzione-deposito-no-esproprio-dto';
export * from './lib/depositi/models/dati-deposito-dto';
export * from './lib/depositi/models/altri-soggetti-giudiziario-dto';
export * from './lib/depositi/models/autorita-ordinante-dto';
export * from './lib/depositi/models/dati-deposito-no-esproprio-dto';
export * from './lib/depositi/models/altri-soggetti-no-esproprio-dto';
export * from './lib/depositi/models/persona-fisica-dto';
export * from './lib/depositi/models/info-anagrafiche-pf';
export * from './lib/depositi/models/info-nascita-pf.dto';
export * from './lib/depositi/models/persona-giuridica-dto';
export * from './lib/depositi/models/ente-richiedente-cauzione-dto';
export * from './lib/depositi/models/autorita-espropriante-dto';
export * from './lib/depositi/models/contatto-dto';
export * from './lib/depositi/models/domicilio-dto';
export * from './lib/depositi/models/indirizzo-dto';
export * from './lib/depositi/models/particella-dto';
export * from './lib/depositi/models/dichiarazione-dto';
export * from './lib/depositi/models/dati-richiedente-dto';
export * from './lib/depositi/models/rappresentante-dto';
export * from './lib/depositi/models/utente';
export * from './lib/depositi/models/documento-dto';
export * from './lib/depositi/models/bozza-deposito-dto';
export * from './lib/depositi/models/identificativo-richiesta-dto';
export * from './lib/depositi/models/creazione-bozza-response';
export * from './lib/depositi/models/comune-dto';
export * from './lib/depositi/models/proprietario-dto';
export * from './lib/depositi/models/provincia-dto';
export * from './lib/depositi/models/dati-opera-dto';
export * from './lib/depositi/services/message.service';
export * from './lib/depositi/utils/modals';
export * from './lib/depositi/utils/component-reducer';
export * from './lib/depositi/models/natura-richiedente-request.dto';
export * from './lib/depositi/models/natura-richiedente.dto';
export * from './lib/depositi/models/tipi-documento-request.dto';
export * from './lib/depositi/models/tipo-documento.dto';
export * from './lib/depositi/models/tribunale-dto';
export * from './lib/depositi/models/localita-dto';
export * from './lib/depositi/models/strada-dto';
export * from './lib/depositi/models/contatto-dto';
export * from './lib/depositi/models/rts-dto';
export * from './lib/depositi/models/regione-dto';
export * from './lib/depositi/models/nazione.dto';

//----Servizi-Depositi-----//
export * from './lib/depositi/services/tipologiche/tipologiche.service';
export * from './lib/depositi/services/deleghe-services/deleghe.service';
export * from './lib/depositi/services/territorio/territorio-service';
export * from './lib/depositi/services/utente/utente.service';
export * from './lib/depositi/utils/fnutils';

//----------Allegati--AND--PAGAMENTO-----//
export * from './lib/allegati/allegati.module';
export * from './lib/allegati/components/allegati.component';
export * from './lib/pagamenti/pagamenti.module';
export * from './lib/pagamenti/components/lista-pagamenti/lista-pagamenti.component';
export * from './lib/pagamenti/models/cronologiaStato-dto';
export * from './lib/configuration/configuration.module';

//----------InfoTip--------//
export * from './lib/info-tip/info-tip.module';
export * from './lib/info-tip/info-tip.directive';
export * from './lib/info-tip/info-tip-label/info-tip-label.component';

//----------Uppercase directive--------//
export * from './lib/directives/upper-case.module';
export * from './lib/directives/upper-case.directive';


// ----------Modalita Pagamento--------//
export * from './lib/modalita-pagamento/modalita-pagamento.module';

export * from './lib/modalita-pagamento/components/bonifico-sepa/bonifico-sepa.component';
export * from './lib/modalita-pagamento/components/estremi-persona-fisica/estremi-persona-fisica.component';
export * from './lib/modalita-pagamento/components/bonifico-extra-sepa/bonifico-extra-sepa.component';
export * from './lib/modalita-pagamento/components/indirizzo-pagamento/indirizzo-pagamento.component';
export * from './lib/modalita-pagamento/components/vaglia-bdi/vaglia-bdi.component';

export * from './lib/modalita-pagamento/constants/forms/modalita-pagamento-extra-sepa-form.defaults';
export * from './lib/modalita-pagamento/constants/forms/modalita-pagamento-vaglia-form.defaults';

export * from './lib/modalita-pagamento/models/form/country-dto';
export * from './lib/modalita-pagamento/models/form/modalita-pagamento-extra-sepa-form.model';
export * from './lib/modalita-pagamento/models/validators.model';
export * from './lib/modalita-pagamento/models/tipologia-richiedente.model';
export * from './lib/modalita-pagamento/models/estremi-persona-fisica.model';
export * from './lib/modalita-pagamento/models/form/modalita-pagamento-vaglia-form.model';

export * from './lib/modalita-pagamento/utils/validators-messages.utils';
export * from './lib/modalita-pagamento/utils/validators.utils';

